import React from 'react';
import './LecturePlaylist.less';
import {Link} from 'react-router';
import {Row, Column, Item} from 'react-plan';
import { observer } from 'mobx-react';

type Props = {
  courseId: string,
  currentLecture: string
}

@observer(['lectures', 'enrollments'])
class LecturePlaylist extends React.Component {

  description: 'Playlist to navigate through the lectures of a course.'

  props: Props

  constructor(props: Props) {
    super(props);
    this.store = props.lectures;
  }

  /* Component Custom Methods */
  renderList = () => {
    const lectures = this.store.getLecturesByCourseId(this.props.courseId);
    return lectures.map(([id, lecture]) => {
      let playing = null;
      let lectureClass = 'lecture no-underline';
      if (id === this.props.currentLecture) {
        playing = <h4 data-icon="x" className="icon picto-lecture" />;
        lectureClass += ' playing';
      }
      else {
        const enrollment = this.props.enrollments.lectures.get(id);
        playing = (enrollment) ? <i className="icon-check"></i> : null;
      }
      return (
        <Link to={ `/lecture/${id}` } className={ lectureClass } key={ id }>
          <Row align="center" className="container p" justify="space-between">
            <Item size="10%" className="status">
              { playing }
            </Item>
            <Item size="10%" >
              <span data-icon="q" className="icon icon-type m-r" />
            </Item>
            <Item size="60%">
              <p>{ lecture.name }</p>
            </Item>
            <Item size="20%">
              <span className="grey"><span data-icon="z" className="icon icon-time" />{ lecture.duration }</span>
            </Item>
          </Row>
        </Link>
      );
    });
  }
  /* End Component Custom Methods */

  /* React Component LifeCycle Methods */
  componentWillMount() {
    this.store.loadByCourseId(this.props.courseId);
  }
  //componentDidMount() {}
  //componentWillReceiveProps(nextProps) {}
  //shouldComponentUpdate(nextProps, nextState) {}
  //componentWillUpdate(nextProps, nextState) {}
  //componentDidUpdate(prevProps, prevState) {}
  //componentWillUnmount() {}
  render() {

    return (
      <div className="lecture-playlist">
        { this.renderList() }
      </div>
    );
  }
  /* End React Component LifeCycle Methods */
}

export default LecturePlaylist;

//Unit test entry point
export const LecturePlaylistTest = LecturePlaylist;



/** WEBPACK FOOTER **
 ** ./src/js/lecture/LecturePlaylist/LecturePlaylist.jsx
 **/